var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', {
    staticClass: "overflow-visible",
    attrs: {
      "aspect-ratio": 5 / 7
    }
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "upload",
    attrs: {
      "type": "file",
      "accept": "image/*,image/heic,video/*,video/3gpp"
    },
    on: {
      "input": function (e) {
        return _vm.handleFile(e.target.files[0]);
      }
    }
  }), _c('v-card', {
    staticClass: "absolute-fill d-flex justify-center align-center",
    class: {
      'drop-zone': _vm.isDragging
    },
    attrs: {
      "hover": "",
      "tile": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.upload.click();
      }
    },
    nativeOn: {
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.onDrop.apply(null, arguments);
      }
    }
  }, [_vm.isDragging ? _c('v-btn', {
    attrs: {
      "icon": "",
      "x-large": "",
      "color": "white"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiUpload)
    }
  })], 1) : _vm.url ? [_vm.video ? _c('video', {
    staticClass: "user-select-none absolute-fill",
    staticStyle: {
      "object-fit": "cover",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "playsinline": "",
      "autoplay": "autoplay",
      "muted": "muted",
      "loop": "loop",
      "draggable": "false",
      "src": _vm.url
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    staticClass: "user-select-none absolute-fill",
    staticStyle: {
      "object-fit": "cover",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "draggable": "false",
      "src": _vm.url
    }
  })] : _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "x-large": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlusCircleOutline)
    }
  })], 1)], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }